module.exports = __webpack_public_path__ + "assets/img/haveObtained_bg.ec5cd8c6.png";